export default __webpack_public_path__ + "static/media/shoes_syrie.3c9ae9a5.svg";